import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const fetchAllLegalEntities = () => {
  return axiosInstance.get(`${URLS.legalEntities}/`);
};

const fetchLegalEntityTeams = (leId) => {
  return axiosInstance.get(`${URLS.legalEntities}/${leId}/teams/`);
};

const createLegalEntity = (data) => {
  return axiosInstance.post(`${URLS.legalEntities}/`, data);
};

const updateLegalEntity = (leId, data) => {
  return axiosInstance.patch(`${URLS.legalEntities}/${leId}/`, data);
};

const deleteLegalEntity = (leId) => {
  return axiosInstance.delete(`${URLS.legalEntities}/${leId}/`);
};

const fetchLegalEntityMembers = (leId) => {
  return axiosInstance.get(`${URLS.legalEntities}/${leId}/members/`);
};

const removeLegalEntityMember = (leId, userId) => {
  return axiosInstance.delete(`${URLS.legalEntities}/${leId}/members/${userId}/`);
};

const elevateLegalEntityMember = (leId, userId) => {
  return axiosInstance.post(`${URLS.legalEntities}/${leId}/elevate/${userId}/`);
};

const fetchLegalEntityInvitations = (leId) => {
  return axiosInstance.get(`${URLS.legalEntities}/${leId}/invitations/`);
};

const sendLegalEntityInvitation = (leId, { invitedUserId, inviteAsAdmin, message }) => {
  return axiosInstance.post(`${URLS.legalEntities}/${leId}/invitations/`, {
    invited_user_id: invitedUserId,
    invite_as_admin: inviteAsAdmin,
    message,
  });
};

const revokeLegalEntityInvitation = (leId, invitationId) => {
  return axiosInstance.delete(
    `${URLS.legalEntities}/${leId}/invitations/${invitationId}/revoke/`
  );
};

export const legalEntitiesApi = {
  fetchAll: fetchAllLegalEntities,
  fetchTeams: fetchLegalEntityTeams,
  create: createLegalEntity,
  update: updateLegalEntity,
  deleteOne: deleteLegalEntity,
  fetchMembers: fetchLegalEntityMembers,
  removeMember: removeLegalEntityMember,
  elevateMember: elevateLegalEntityMember,
  fetchInvitations: fetchLegalEntityInvitations,
  sendInvitation: sendLegalEntityInvitation,
  revokeInvitation: revokeLegalEntityInvitation,
};
